import React from "react";
import NavItem from "./NavItem";
import BookingButton from "./BookingButton";
import { NavItem as NavItemType } from "@/types/navbar";

interface DesktopNavProps {
  navItems: NavItemType[];
  bookingUrl?: string;
  scrolled: boolean;
  handleAnchorClick: (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => void;
}

const DesktopNav: React.FC<DesktopNavProps> = ({ 
  navItems, 
  bookingUrl = "https://zeeg.me/joerghoermann", 
  scrolled, 
  handleAnchorClick 
}) => {
  return (
    <nav className="hidden md:flex items-center">
      <ul className="flex items-center space-x-0 xl:space-x-1">
        {/* Navigation items */}
        {navItems.map((item) => (
          <NavItem
            key={item.name}
            name={item.name}
            link={item.link}
            scrolled={scrolled}
            onClick={(e) => {
              if (item.link.includes('#')) {
                handleAnchorClick(e, item.link.substring(item.link.indexOf('#')));
              }
            }}
          />
        ))}
        
        <li>
          <BookingButton url={bookingUrl} scrolled={scrolled} />
        </li>
      </ul>
    </nav>
  );
};

export default DesktopNav;